<template>
  <div class="login">
    <h1>{{ msg }}</h1>
    <h2>登录表单</h2>
        <form @submit.prevent="submitLogin">
              <label for="name">用户名</label><input type="text" name="name" v-model="account" /><br/>
      <label for="password">密码</label><input type="password" name="password" v-model="password" /><br/>
              <input type="submit" value="登录" />
    </form>
          </div>
</template>

<script>
import axios from "axios"
export default {
  name: 'Login',
  data () {
    return {
      msg: '后台登录',
      account: "",
      password: ""
    }
  },
  methods: {
submitLogin(event) {
const formData = {
phone: this.account,
password: this.password,
time: (new Date().getTime() / 1000),
}
const sig = this.checkSig(formData)
                axios.post(`${this.WEBCONF.url}users/login?sig=${sig}`, formData, {
                'Content-Type': 'application/json'
                })
    .then(response => {
        if(response.status==200) {
                    if(response.data.code==0) {
                    sessionStorage.setItem("uid",response.data.data.user.uid)
                    sessionStorage.setItem("nickname",response.data.data.user.nickname)
    sessionStorage.setItem("account",this.account)
    sessionStorage.setItem("token",response.data.data.user.access_token)
    sessionStorage.setItem("typ",response.data.data.user.role)
    sessionStorage.setItem("amount",0)
    this.$emit("login_succeed",response.data.data.user.uid,response.data.data.user.nickname,this.account,response.data.data.user.role,0)
    this.$router.push({name:"Home"})
                            } else {
            alert(response.data.reason);
    }
    }
    }).catch(err => {
    alert("网络错误。");
    })
   
        }
      }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue